import React from "react";

import Image from "next/image";
import CloseIcon from "public/icons/close.svg";
import BlackFridayLeftImage from "public/images/black-friday---banner-left.png";
import BlackFridayRightImage from "public/images/black-friday---banner-right.png";
import BlackFridayLeftImageMobile from "public/images/black-friday-mobile-banner-left.png";
import BlackFridayRightImageMobile from "public/images/black-friday-mobile-banner-right.png";

import { styled } from "@mui/material";

import { Button } from "@/components/form/Button/Button";
import { useOpenModal } from "@/components/modal/utils/openModal";
import { SvgIcon } from "@/components/ui/svg-icon/SvgIcon";
import { clsxm } from "@/utils/tailwindMerge";

import { useSecondaryLayoutTopBannerContext } from "../context";

export const BlackFridayBanner: React.FC = () => {
  const { closeBanner } = useSecondaryLayoutTopBannerContext();

  const { openModal, removeOne } = useOpenModal();

  const openRegisterModal = () =>
    openModal("REGISTER_FORM_MODAL", {
      onClose: removeOne,
    });

  return (
    <div className="w-screen ml-[calc(-50vw_+_50%)]">
      <div className="flex justify-center bg-[#252525] relative">
        <div className="h-full w-full">
          <div
            className={clsxm(
              "relative overflow-clip w-full",
              "flex justify-center items-center",
              "md:h-[54px] h-[80px]",
            )}
          >
            <Image
              src={BlackFridayLeftImage}
              alt="Halloween Offer Hello"
              className={clsxm(
                "absolute left-1 bottom-0",
                "max-w-none",
                "hidden md:block",
              )}
            />
            <Image
              src={BlackFridayRightImage}
              alt="Halloween Offer Hello"
              className={clsxm(
                "absolute right-1",
                "max-w-none",
                "hidden md:block",
              )}
            />

            <Image
              src={BlackFridayLeftImageMobile}
              alt="Black Friday Offer"
              className={clsxm(
                "absolute left-[0.35rem]",
                "max-w-none",
                "md:hidden",
              )}
            />
            <Image
              src={BlackFridayRightImageMobile}
              alt="Halloween Offer Hello"
              className={clsxm(
                "absolute right-[0.35rem]",
                "max-w-none",
                "md:hidden",
              )}
            />

            <div className="flex flex-col items-center gap-1 md:gap-2 md:flex-row z-[1]">
              <div className="text-white text-base md:text-2xl [text-shadow:_#252525_0px_0_10px,_#252525_0px_0_10px,_#252525_0px_0_10px]">
                <span className="font-bold text-[#FBD132]">BLACK FRIDAY:</span>{" "}
                <span>25 </span>
                <span className="text-xs md:text-sm">Nov - </span>
                <span> 2 </span>
                <span className="text-xs md:text-sm">Dec. </span>
                <span className="text-xs md:text-sm">Special offer</span>
              </div>
              <Button
                onClick={openRegisterModal}
                className="bg-[#FBD132] hover:bg-[#FBD132] text-black text-sm h-7"
              >
                Purchase coins
              </Button>
            </div>
          </div>
        </div>
        <Button
          variant="outlined"
          onClick={closeBanner}
          className={clsxm(
            "h-[32px] w-[32px] min-w-min p-0 absolute z-[1]",
            "md:right-4 md:top-1/2 md:transform md:-translate-y-1/2",
            "right-2 top-1",
            "border-none hover:border-none bg-opacity-0",
          )}
          startIcon={
            <SvgCloseIcon>
              <CloseIcon />
            </SvgCloseIcon>
          }
        ></Button>
      </div>
    </div>
  );
};

const SvgCloseIcon = styled(SvgIcon)({
  "& path": {
    fill: "white",
  },
});
